/* eslint-disable no-underscore-dangle */
/**
 * Brief product description expanding and collapsing
 * @param {element} product
 * @param {function} callback
 * @constructor
 */
function ProductDesc(product, callback) {
  this.__product = product;
  this.__element = this.__product.querySelector('[data-component="product-desc"]');
  this.__callback = callback || null;

  if (this.__element !== null) {
    this.__isOpened = false;
    this.__closedElement = this.__element.querySelector('.product-desc-toggle-closed');
    this.__openedElement = this.__element.querySelector('.product-desc-toggle-opened');
    this.__descWrapper = this.__product.querySelector('.product-desc-wrapper');
    this.__badges = this.__product.querySelector('.badges');

    this.__closedElement.addEventListener('click', this.onOpen.bind(this), false);
    this.__openedElement.addEventListener('click', this.onClose.bind(this), false);
  }
}

/**
 * Open handler
 */
ProductDesc.prototype.onOpen = function onOpen(event) {
  event.stopPropagation();
  event.preventDefault();

  this.open();
};

/**
 * Close handler
 */
ProductDesc.prototype.onClose = function onClose(event) {
  event.stopPropagation();
  event.preventDefault();

  this.close();
};

/**
 * Open product description
 */
ProductDesc.prototype.open = function open() {
  if (!this.__isOpened) {
    this.__isOpened = true;
    this.__closedElement.style.display = 'none';
    this.__openedElement.style.display = 'block';

    if (typeof this.__callback === 'function') {
      this.__callback(this.__product, this, true);
    }
  }
};

/**
 * Close product description
 */
ProductDesc.prototype.close = function close() {
  if (this.__isOpened) {
    this.__isOpened = false;
    this.__closedElement.style.display = 'block';
    this.__openedElement.style.display = 'none';

    if (typeof this.__callback === 'function') {
      this.__callback(this.__product, this, false);
    }
  }
};

module.exports = ProductDesc;
